import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import SiteRender from "@/components/diy/SiteRender";

function Site({ d, client = api }) {
  useEffect(() => { document.title = d.setup?.brand?.company || d.site.pages[0]?.title || "Website"; }, [d]);
  const enquire = async (f) => { try { return (await client.post(`/public/sites/${d.slug}/enquiry`, f)).data.message; } catch (e) { throw new Error(errMsg(e)); } };
  return <div className="min-h-screen bg-white" data-testid="public-site"><SiteRender site={d.site} setup={d.setup} media={d.media} onEnquire={enquire} /></div>;
}

export default function SitePage() {
  const { slug } = useParams();
  const [d, setD] = useState(null); const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/sites/${slug}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [slug]);
  if (err) return <div className="min-h-screen grid place-items-center text-sm" data-testid="site-not-found">{err}</div>;
  if (!d) return <div className="min-h-screen" />;
  return <Site d={d} />;
}

const sameOrigin = axios.create({ baseURL: `${window.location.origin}/api` });

export function DomainSite({ onMissing }) {
  const [d, setD] = useState(null);
  useEffect(() => { sameOrigin.get(`/public/sites/by-domain/${window.location.hostname}`).then((r) => setD(r.data)).catch(() => onMissing()); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <div className="min-h-screen" />;
  return <Site d={d} client={sameOrigin} />;
}
